import React from 'react';
import { Prompt } from 'react-router-dom';
import { Modal } from 'antd';
import PropTypes from 'prop-types';

const confirm = Modal.confirm;

export default class LeaveAlert extends React.Component {
  constructor() {
    super();
    this.state = {
      modalVisible: false,
      confirmedNavigation: false,
    };
  }

  componentDidMount() {
    const { closeAlertContent } = this.props;
    if (closeAlertContent) {
      // add browser alert
      window.onbeforeunload = e => {
        if (this.props.when) {
          const msg = closeAlertContent;
          // eslint-disable-next-line no-param-reassign
          e = e || window.event;
          if (e) {
            e.returnValue = closeAlertContent;
          }

          return msg;
        }
        return null;
      };
    }
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  getContent = () => {
    const { content, contentType, t } = this.props;
    if (content) {
      return content;
    }
    return contentType && contentType === 'create'
      ? t('cms:cms.properties.create.leave_alert.content')
      : t('cms:cms.properties.edit.leave_alert.content');
  };

  showModal = location => {
    this.setState(
      {
        modalVisible: true,
      },
      () =>
        confirm({
          title: this.props.titleText || this.props.t('cms:cms.properties.edit.leave_alert.title'),
          content: this.getContent(),
          okText:
            this.props.okText || this.props.t('cms:cms.properties.edit.leave_alert.button.yes'),
          cancelText:
            this.props.cancelText ||
            this.props.t('cms:cms.properties.edit.leave_alert.button.cancle'),
          onOk: () => {
            this.handleConfirmNavigationClick(location);
          },
        }),
    );
  };

  closeModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  handleBlockedNavigation = nextLocation => {
    const { confirmedNavigation } = this.state;
    if (!confirmedNavigation) {
      this.showModal(nextLocation);
      return false;
    }

    return true;
  };

  handleConfirmNavigationClick = location => {
    const { history } = this.props;
    this.setState(
      {
        modalVisible: false,
        confirmedNavigation: true,
      },
      () => {
        this.props.onConfirmLeavePage();
        if (location.state && location.state.logoutUser) {
          location.state.logoutUser();
        }
        return history.push(location.pathname + location.search);
      },
    );
  };

  render() {
    return (
      <div>
        <Prompt when={this.props.when} message={this.handleBlockedNavigation} />
      </div>
    );
  }
}

LeaveAlert.propTypes = {
  history: PropTypes.object.isRequired,
  when: PropTypes.bool,
  t: PropTypes.func.isRequired,
  contentType: PropTypes.string,
  onConfirmLeavePage: PropTypes.func,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  titleText: PropTypes.string,
  closeAlertContent: PropTypes.string,
};

LeaveAlert.defaultProps = {
  history: {
    pathname: '',
  },
  when: false,
  t: () => {},
  contentType: '',
  onConfirmLeavePage: () => {},
  content: '',
  okText: '',
  cancelText: '',
  titleText: '',
  closeAlertContent: '',
};
